interface DeleteImageResponse {
  message: string;
  key: string;
}

interface DeleteImageError {
  error: string;
  key?: string;
}

export const deleteImageFromS3 = async (
  imageKey: string,
): Promise<DeleteImageResponse> => {
  const apiUrl =
    import.meta.env.VITE_API_POST_MEDIA ||
    'https://6i67b2slal.execute-api.us-east-2.amazonaws.com';
  const stage = import.meta.env.VITE_STAGE || 'dev';

  try {
    const response = await fetch(
      `${apiUrl}/${stage}/delete-media/${imageKey}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          // TODO: do I need authorization headers here?
        },
      },
    );

    if (!response.ok) {
      const errorData: DeleteImageError = await response.json();
      throw new Error(
        errorData.error || `Failed to delete image: ${response.status}`,
      );
    }

    const data: DeleteImageResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting image from S3:', error);
    throw error;
  }
};
